import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter } from "@/components/ui/alert-dialog";

export default function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel = "Confirm", onConfirm, danger = true }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-none border-kl-black p-0 gap-0 max-w-md" data-testid="confirm-dialog">
        <AlertDialogHeader className="p-6 bg-kl-black text-white text-left">
          <AlertDialogTitle className="font-display font-light text-xl">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-kl-muted">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="p-4 gap-2">
          <button onClick={() => onOpenChange(false)} className="kl-btn-outline" data-testid="confirm-cancel-button">Cancel</button>
          <button onClick={onConfirm} className={`kl-btn ${danger ? "bg-kl-inactive text-white hover:bg-red-600" : "kl-btn-primary"}`} data-testid="confirm-accept-button">{confirmLabel}</button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
